export const dateFormats = {
  MDY: 'MM/dd/yyyy',
  DMY: 'dd/MM/yyyy',
  YMD: 'yyyy/MM/dd',
  MMMDY: 'MMM dd yyyy',
  DMMMY: `dd MMM yyyy`,
}
